(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[18938],{

/***/ 23462:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/logoff",
      function () {
        return __webpack_require__(21014);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 25356:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* reexport */ Layout; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../brand/components/index.ts + 163 modules
var components = __webpack_require__(46731);
// EXTERNAL MODULE: ./src/components/organisms/index.ts + 50 modules
var organisms = __webpack_require__(79427);
// EXTERNAL MODULE: ./src/hooks/index.ts + 17 modules
var hooks = __webpack_require__(55102);
// EXTERNAL MODULE: ./src/helpers/getQueryVariable.ts
var getQueryVariable = __webpack_require__(35617);
;// CONCATENATED MODULE: ./src/components/layouts/Layout.tsx








var Layout = function(_param) {
    var _hasHeader = _param.hasHeader, hasHeader = _hasHeader === void 0 ? true : _hasHeader, _isMenuSticky = _param.isMenuSticky, isMenuSticky = _isMenuSticky === void 0 ? true : _isMenuSticky, props = (0,_object_without_properties/* default */.Z)(_param, [
        "hasHeader",
        "isMenuSticky"
    ]);
    var locale = (0,hooks/* useTranslation */.$G)().locale;
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        router.events.on("routeChangeStart", function() {
            setIsOpen(false);
        });
        return function() {
            setIsOpen(false);
        };
    }, []);
    (0,react.useEffect)(function() {
        var html = document.querySelector("html");
        if (html) html.lang = locale;
    }, [
        locale
    ]);
    (0,react.useEffect)(function() {
        (0,getQueryVariable/* saveMarketingData */.L)();
    }, []);
    var renderHeader = function() {
        if (hasHeader) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    isOpen && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(organisms/* MenuMobile */.XN, {
                        alternativeLinks: props.alternativeLinks || []
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(organisms/* MenuDesktop */.WA, {
                        alternativeLinks: props.alternativeLinks,
                        isOpen: isOpen,
                        setIsOpen: setIsOpen,
                        isSticky: isMenuSticky,
                        hasCta: props.hasCta
                    })
                ]
            });
        }
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {});
    };
    var renderFooter = function() {
        switch(props.hasFooter){
            case "none":
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {});
            default:
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(organisms/* Footer */.$_, {});
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(components/* Box */.xu, {
        as: "section",
        children: [
            renderHeader(),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("main", {
                role: "main",
                children: props.children
            }),
            renderFooter()
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/layouts/index.ts



/***/ }),

/***/ 35617:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ saveMarketingData; }
/* harmony export */ });
/* unused harmony export getQueryVariable */
/* harmony import */ var _hoa_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88731);
// @ts-nocheck

var getQueryVariable = function(variable) {
    var search = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var query = search.substring(1);
    var vars = query.split("&");
    for(var i = 0; i < vars.length; i += 1){
        var pair = vars[i].split("=");
        if (decodeURIComponent(pair[0]) === variable) {
            return decodeURIComponent(pair[1]);
        }
    }
    return null;
};
var saveMarketingData = function() {
    var utmParameters = {
        utmSource: getQueryVariable("utm_source", window.location.search),
        utmCampaign: getQueryVariable("utm_campaign", window.location.search),
        utmMedium: getQueryVariable("utm_medium", window.location.search),
        utmPage: getQueryVariable("utm_page", window.location.search)
    };
    //Disabled since utmsource 'organic' was not correct
    // if (!sessionStorage.getItem(LocalStorage.UTM_PARAMETERS)) {
    //   utmParameters.utmSource =
    //     !utmParameters.utmSource &&
    //     document &&
    //     document.referrer &&
    //     document.referrer.includes('google')
    //       ? 'organic'
    //       : utmParameters.utmSource;
    // }
    if (utmParameters.utmSource) {
        sessionStorage.setItem(_hoa_config__WEBPACK_IMPORTED_MODULE_0__/* .LocalStorage.UTM_PARAMETERS */ .mM.UTM_PARAMETERS, JSON.stringify(utmParameters));
    }
    if (sessionStorage.getItem(_hoa_config__WEBPACK_IMPORTED_MODULE_0__/* .LocalStorage.GCLID_PARAMETERS */ .mM.GCLID_PARAMETERS) === null && getQueryVariable("gclid", window.location.search) !== null) {
        sessionStorage.setItem(_hoa_config__WEBPACK_IMPORTED_MODULE_0__/* .LocalStorage.GCLID_PARAMETERS */ .mM.GCLID_PARAMETERS, getQueryVariable("gclid", window.location.search));
    }
};


/***/ }),

/***/ 21014:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LogOffPage": function() { return /* binding */ LogOffPage; },
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52903);
/* harmony import */ var _brand_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46731);
/* harmony import */ var _hoa_atoms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97347);
/* harmony import */ var _hoa_layouts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25356);
/* harmony import */ var _hoa_hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55102);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2784);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21805);
/* harmony import */ var _hoa_config__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88731);








var __N_SSG = true;
var LogOffPage = function() {
    var t = (0,_hoa_hooks__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)().t;
    var ErrorHeroImage = "".concat("https://cdn.jaimy.be", "/images/hero-images/jaimy-404.jpg");
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        js_cookie__WEBPACK_IMPORTED_MODULE_5__/* ["default"].remove */ .Z.remove(_hoa_config__WEBPACK_IMPORTED_MODULE_6__/* .LocalStorage.COOKIE_NAME */ .mM.COOKIE_NAME);
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = "/";
    }, []);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_hoa_atoms__WEBPACK_IMPORTED_MODULE_1__/* .Seo */ .pQ, {
                title: t("category:seo.title"),
                description: t("category:seo.description"),
                indexed: false
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_hoa_layouts__WEBPACK_IMPORTED_MODULE_2__/* .Layout */ .A, {
                hasHeader: true,
                hasFooter: "small",
                isMenuSticky: false,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_0__/* .Box */ .xu, {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    height: "100vh",
                    backgroundImage: ErrorHeroImage,
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_0__/* .Card */ .Zb, {
                        display: "flex",
                        width: "80%",
                        minH: "40%",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "space-around",
                        padding: "50px",
                        backgroundColor: "hsla(0, 0%, 100%, 0.70)",
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_0__/* .Heading */ .X6, {
                            variant: "h5",
                            marginBottom: "25px",
                            children: t("error:logoff.title")
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (LogOffPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [49774,92888,40179], function() { return __webpack_exec__(23462); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);